import React from 'react'
import Logo from '../assets/logo.png'
import Community from '../assets/Community.png'
import Developers from '../assets/Developers.png'

export const LogoLarge = ({
    size = 20
                          }) =>{

    const multiplier = size/30;

    return(
        <div style={{display:'flex',alignItems:'flex-end',padding:0}}>
        <img src={Logo} height={70*multiplier} style={{marginBottom:4}}/>
        <div style={{width:20*multiplier}} />
            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>

                <img src={Community} height={30*multiplier}/>
                <div>
                <img src={Developers} height={20*multiplier}/>
                </div>
            </div>

        </div>
    )
}

export const LogoSmall = ({
    size = 20
})=>{
    const multiplier = size/30;

    return <img src={Logo} height={50*multiplier} style={{marginBottom:4}}/>

}